// Shared gameplay constants. Tweaking balance happens here; everything
// else reads from this module.

export const TILE_SIZE = 32;
export const ARENA_COLS = 30;
export const ARENA_ROWS = 18;
export const GAME_WIDTH = TILE_SIZE * ARENA_COLS; // 960
export const GAME_HEIGHT = TILE_SIZE * ARENA_ROWS; // 576

// Movement
export const MOVE_DURATION_MS = 100;
export const MOVE_REPEAT_DELAY_MS = 220;
export const MOVE_REPEAT_RATE_MS = 110;

// Mana regen (the unwired recuperaMana bug from 2011 — now wired)
export const MANA_REGEN_INTERVAL_MS = 500;
export const MANA_REGEN_AMOUNT = 1;

// Map fire tiles
export const FIRE_TILE_COUNT = 24;
export const FIRE_TILE_DAMAGE = 40;
export const SPAWN_EXCLUSION_RADIUS = 3;

// Combat costs
export const FIRE_MANA_COST = 20;
export const HEAL_MANA_COST = 25;

// Fire projectile
export const PROJECTILE_SPEED = 360; // px / second
export const PROJECTILE_MAX_TILES = 7;

// Spawns — opposite ends, middle row
export const PLAYER1_SPAWN = { col: 4, row: 9 };
export const PLAYER2_SPAWN = { col: ARENA_COLS - 5, row: 9 };

// Vocations
export const VOCATION_STATS = {
  warrior: {
    maxHp: 1000,
    maxMana: 100,
    fistMax: 100, // punch damage rolls 1..fistMax
    magicLevel: 1, // projectile damage = magicLevel * 1d30
    healDie: 100, // heal restores 1..healDie
  },
  mage: {
    maxHp: 500,
    maxMana: 500,
    fistMax: 10,
    magicLevel: 10,
    healDie: 300,
  },
} as const;

// Directions are unit vectors so movement and projectiles share the same shape.
export const Directions = {
  Left: { x: -1, y: 0 },
  Right: { x: 1, y: 0 },
  Up: { x: 0, y: -1 },
  Down: { x: 0, y: 1 },
} as const;
export type Direction = (typeof Directions)[keyof typeof Directions];
